<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="doctor_wrap" v-for="d in transedArray" :key="d.id">
            <div class="dw_info list">
              <div class="profile_wrap">
                <div class="dw_imgWrap">
                  <img :src="'https://adminapi.thanq.kr' + d.photoUrl" />
                </div>
                <div class="profile_info">
                  <div class="imgWrap">
                    <img src="@/assets/images/logo_t.png" />
                  </div>
                  <div class="dw_title">
                    <p>{{d.name}}</p>
                  </div>
                  <div class="dw_detail">
                    <p>{{d.specialtyMajor}} {{d.specialtySubject}} 전문의</p>
                    <p>{{d.job}}</p>
                  </div>
                </div>
              </div>
              <div class="dw_profile">
                <BaseAccordion :basic="basic">
                  <template v-slot:title>
                    <div class="detail">
                      <p>열어서 보기</p>
                      <div class="imgWrap">
                        <img src="@/assets/images/arrow.svg" />
                      </div>
                    </div>
                  </template>

                  <template v-slot:content>
                    <div class="accordion">
                      <div class="accordion_title">
                        <h3>약력</h3>
                      </div>
                      <div class="accordion_content history">
                        <p>
                          <!--                        <span class="check_img">-->
                          <!--                          <img src="@/assets/images/red_ck.svg">-->
                          <!--                        </span>-->
                          {{d.history}}
                        </p>
                      </div>
                    </div>
                  </template>
                </BaseAccordion>
                <!--                <div class="detail">-->
                <!--                  <p>{{d.job}}</p>-->
                <!--                  <div class="imgWrap" :class="{rotate : form.doctorInfo.open}">-->
                <!--                    <img src="@/assets/images/click_1.svg">-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
            </div>
            <!--            <div class="accordion_menu">-->
            <!--              <div class="accordion_title">-->
            <!--                <h3>진료 가능한 수술/시술</h3>-->
            <!--              </div>-->
            <!--              <div class="accordion_content" v-for="s in d.surgery_list" :key="s.id">-->
            <!--                <p><img src="@/assets/images/red_ck.svg">{{s.content}}</p>-->
            <!--              </div>-->
            <!--              <div class="accordion_content" v-for="c in d.checkup_list" :key="c.id">-->
            <!--                <p><img src="@/assets/images/red_ck.svg">{{c.content}}</p>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
      <!--      <div class="btnWrap visible">-->
      <!--        <router-link to="/">-->
      <!--          <button type="button" class="callTerms">확인</button>-->
      <!--        </router-link>-->
      <!--      </div>-->
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import AddPopup from "@/components/AddPopup";
import BaseAccordion from "@/components/BaseAccordion";
import errorParser from "@/utils/error-parser";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      basic: {
        isShow: false,
        isOpen: false,
      },
      popupSet: {
        title: "",
        modalImg: "alert_cn.svg",
        content: "",
        confirmBtnText: "확인",
        count: "single",
      },
      transDate: {
        headerName: "의료진 소개",
        prevUrl: "/",
      },
      form: {
        doctorInfo: {
          open: false,
        },
        history: [
          {
            value: [],
          },
        ],
        historyValue: [{}],
      },
      transedArray: [],
      setCount: false,
    };
  },
  computed: {
    ...mapGetters(["getDoctorList"]),
    ...mapState(["checkPopup"]),
  },
  watch: {},
  methods: {
    ...mapMutations(["SET_POPUP"]),
    ...mapActions(["DOCTOR_LIST"]),
    // toggleEvent () {
    //   const areaArr = document.querySelectorAll('.doctor_wrap')
    //
    //   areaArr.forEach((area) => {
    //     const content = area.querySelector('.accordion_menu')
    //     const btn = area.querySelector('.detail')
    //     const arrow = btn.querySelector('.imgWrap')
    //
    //     btn.addEventListener('click', (e) => {
    //       e.preventDefault()
    //       /* 한개 열리면 다른건 접히도록 */
    //       // if (content.classList.contains('show')) {
    //       //   areaArr.forEach((el) => {
    //       //     el.childNodes[1].classList.remove('show')
    //       //   })
    //       // }
    //       arrow.classList.toggle('rotate')
    //       content.classList.toggle('show')
    //     })
    //   })
    // },
    async fetchData() {
      try {
        this.DOCTOR_LIST().then(() => {
          this.carryData();
        });
      } catch (error) {
        console.log('error :', error);
        console.log("의료진 리스트 api에서 에러발생");
        if (error.status !== 401) {
          this.SET_POPUP(true);
          this.popupSet.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      }
    },
    carryData() {
      const doctorOrder = JSON.parse(JSON.stringify(this.getDoctorList));
      const material = [];
      const another = [];
      for (let i = 0; i < doctorOrder.length; i++) {
        if (doctorOrder[i].name.slice(0, 3) === "하정훈") {
          material[0] = doctorOrder[i];
        } else if (doctorOrder[i].name.slice(0, 3) === "천병준") {
          material[1] = doctorOrder[i];
        } else if (doctorOrder[i].name.slice(0, 3) === "이은정") {
          material[2] = doctorOrder[i];
        } else if (doctorOrder[i].name.slice(0, 3) === "이수영") {
          material[3] = doctorOrder[i];
        } else {
          another.push(doctorOrder[i]);
        }
        /**
         *  else if (doctorOrder[i].name.slice(0, 3) === "강경호") {
          material[1] = doctorOrder[i];
        }
         */
      }

      this.transedArray = material.concat(another);
    },
    callPrev() {
      if (this.setCount) {
        this.$router.push("/");
      } else {
        history.go(1);
      }
      this.setCount = true;
      // 클로즈 함수 구현
    },
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup,
    BaseAccordion,
  },
  created() {
    if (history.pushState !== undefined) {
      history.pushState({}, "", location.href);
      window.onpopstate = () => {
        this.callPrev();
      };
    }
    this.fetchData();
  },
  beforeDestroy() {
    this.SET_POPUP(false);
    this.setCount = false;
  },
};
</script>

<style lang="scss" scoped>
</style>
